module.exports = __webpack_public_path__ + "media/images/player/viddsee-logo-9bd244f76b9ff60e837a47ded2de8516.svg";